import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from '../WarrantyRequestModal.module.scss';
import { Option } from '../WarrantyRequestModal.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { getCodeAndTextOfError } from './ArticleInfo.tsx';

type OwnProps = {
  option: Option;
  inputValue: string;
  liProps: HTMLAttributes<HTMLLIElement> & { key: any };
  testId?: string;
  selectedOptions?: Option[];
  optionBody?: React.JSX.Element;
};

export const SelectOption = (props: OwnProps) => {
  const { selectedOptions, option, inputValue, liProps, testId, optionBody } =
    props;
  const { key, ...restLiProps } = liProps;
  const i18n = useScopedTranslation('Page.WarrantyRequest');
  if (!option.text.toLowerCase().includes(inputValue.toLowerCase())) {
    return null;
  }

  const { optionText, optionCode } = getCodeAndTextOfError(option.text);

  const isSelected = !!selectedOptions?.find(
    (selectedOption) => selectedOption.key === option.key,
  );
  return (
    <li
      {...restLiProps}
      data-test-id={testId}
      className={clsx(
        styles.rowContainer,
        styles.columnGap8,
        styles.selectItem,
        isSelected && styles.selectedItem,
      )}
    >
      {optionBody ? (
        optionBody
      ) : (
        <>
          {!isNaN(optionCode) && (
            <div className={styles.label}>{optionCode}</div>
          )}
          <div>
            {optionText.length ? optionText.trim() : i18n.t('option_error')}
          </div>
        </>
      )}
    </li>
  );
};
